
let initCalled = false;

export let serviceWorkerRegistration: ServiceWorkerRegistration | null = null;

export async function loadAdminAreaServiceWorker() {
  if (initCalled) {
    return;
  } else {
    initCalled = true;
  }

  if ("serviceWorker" in navigator) {
    serviceWorkerRegistration =
      await navigator.serviceWorker.register("/sw.js");
    console.log("Service worker registered");
  }
}
